import { request } from "@/utils/request"

/**
 * 登录
 * @param {} data 
 * @returns 
 */
export function login(data) {
  return request({
    url: '/system/auth/login',
    method: 'post',
    data
  })
}

/**
 * 登出
 * @returns 
 */
export function logout(data) {
  return request({
    url: '/system/auth/logout',
    method: 'post',
    data
  })
}

/***
 * 获取当前登录用户信息
 */
export function getUserInfo() {
  return request({
    url: '/system/user/info',
    method: 'get'
  })
}

/**
 * 获取当前登录用户菜单
 * @returns 
 */
export function getUserMenus(params) {
  return request({
    url: '/system/menu/userMenuTree',
    method: 'get',
    params
  })
}

/**
 * 获取当前登录用户同一应用下的用户列表
 * @param {*} params 
 * @returns 
 */
export function getUserList(params) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params
  })
}

/**
 * 保存用户信息
 * @param {*} data 
 * @returns 
 */
export function saveUser(data) {
  return request({
    url: '/system/user/save',
    method: 'post',
    data
  })
}

/**
 * 删除用户
 * @param {*} data 
 * @returns 
 */
export function removeUser(data) {
  return request({
    url: '/system/user/remove',
    method: 'post',
    data
  })
}

/**
 * 保存用户角色
 * @param {*} data 
 * @returns 
 */
export function saveRoles(data) {
  return request({
    url: '/system/user/saveRoles',
    method: 'post',
    data
  })
}

/**
 * 保存用户密码
 * @param {*} data 
 * @returns 
 */
export function savePassword(data) {
  return request({
    url: '/system/user/savePassword',
    method: 'post',
    data
  })
}